module.exports = "/fonts/PT Root UI_Bold.eot?1a30082581039685ec40eab9a68a9e2c";